export default "__VITE_ASSET__D$474up9__"